export const Emblem = ({ className = "h-9 w-auto" }) => (
  <img
    src="/emblem.png"
    alt="MDS Arabama crest"
    className={`select-none object-contain ${className}`}
    draggable="false"
  />
);
